import React from "react";
import useOverView from "./useOverView";
import Style from "./oveview.module.scss";
import GliCardListing from "../../Global/GliCardLIsting";
import QCCardListing from "./QCCardLIsting";
import {
  Button,
  DatePickerWithInput,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import "react-datepicker/dist/react-datepicker.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import FilterForm from "./FilterForm";
import CardDetails from "./CardDetails";
import SubCards from "./SubCards";
import SearchInfo from "../../Global/SearchInfo";
import FilterButton from "../../Global/FilterButton";

const OverView = () => {
  const {
    states,
    state,
    dataArray,
    date,
    isLoading,
    totalLength,
    scrollRef,
    apiStatus,
    inputData,
    searchValue,
    searchItems,
    filterCount,
    handleInputSearch,
    handleClick,
    handleCardView,
    setIsLoading,
    handleSearch,
    handleDateChange,
    handleClearClick,
    handleFilterModal,
    handleLoadMore,
  } = useOverView();

  return (
    <>
      <div className={Style.varifaication_main_wrap}>
        <div className="row">
          <div className={`col ${Style.card_main_wrapper}`}>
            {/* sura didn't added filter in wac pro  */}
            {/* <SearchFilters
              showDateRange={true}
              onSearchInput={handleSearch}
              showFilters={true}
              showActions={false}
              showAdvancedFilterButton={true}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              onDateChange={handleDateChange}
              showClearFilters={true}
              handleClear={handleClearClick}
              initialDateRange={date}
            /> */}
            <div className="row gx-2 gy-2 flex-fill">
              <div className={`col-auto`}>
                <div className="input-wrap">
                  <input
                    type="text"
                    onChange={(e) => {
                      handleInputSearch(e?.target?.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch(); // Trigger search on Enter key
                      }
                    }}
                    placeholder="Search GLI Number"
                    className={`pro-input icon-r lg search-input ${Style.search_table}`}
                    value={inputData}
                  />
                  <span className="pro-icon">
                    {<span className="material-symbols-outlined">search</span>}
                  </span>
                </div>
              </div>
              {/* <div className={"col-auto pro-d-flex pro-items-center"}>
                <SearchInfo searchItems={searchItems}/>
              </div> */}

              <div className={`col-auto`}>
                <button
                  className="pro-btn pro-btn-primary "
                  onClick={handleSearch}
                >
                  <span className="material-symbols-outlined">search</span>
                  Search
                </button>
              </div>
              <div className={`col-auto`}>
                <DatePickerWithInput
                  CalendarOutlineIcon={
                    <span className="material-symbols-outlined">
                      calendar_month
                    </span>
                  }
                  range={true}
                  initialValue={date}
                  onDateChange={handleDateChange}
                ></DatePickerWithInput>
              </div>
              <div className={`col-auto`}>
                <FilterButton
                  onClick={handleFilterModal}
                  filterCount={filterCount}
                  label="Filters"
                />
              </div>
              <div className={`col-auto`}>
                <Button
                  className={"pro-btn-link lg pro-px-5"}
                  onClick={handleClearClick}
                >
                  Clear
                </Button>
              </div>
            </div>
            <ModalLayout
              show={state?.filterModal}
              title={"Filter"}
              handleClose={handleFilterModal}
            >
              <FilterForm />
            </ModalLayout>
            <ModalLayout
              show={state?.viewModal}
              title={"GLI Work Status"}
              handleClose={handleCardView}
              propStyle={{ root: Style.modal_root }}
              closeIcon={
                <span className="material-symbols-outlined">close</span>
              }
            >
              <CardDetails />
            </ModalLayout>
            <ModalLayout
              show={state?.viewSubModal}
              title={"Stock Receipt Details"}
              handleClose={handleClick}
              propStyle={{ root: Style.modal_root }}
              closeIcon={
                <span className="material-symbols-outlined">close</span>
              }
            >
              <SubCards />
            </ModalLayout>
            <div
              className={`${Style.card_scroll_wrap} pro-mt-3`}
              ref={(ref) => (scrollRef.current = ref)}
            >
              <div className={`pro-d-flex ${Style.card_flow_wrap} `}>
                {states?.length === 0 ? null : (
                  <GliCardListing
                    isOverView
                    data={states}
                    title={"GLI Status"}
                    extraClassName={Style.glicard_list}
                    handleLoadMore={handleLoadMore}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    totalLength={totalLength}
                    scrollRef={scrollRef}
                    apiStatus={apiStatus}
                    handleChange={handleClick}
                  />
                )}
                {dataArray?.map((data, index) => (
                  <QCCardListing
                    data={data.data}
                    dataKey={data.key}
                    title={data.title}
                    key={index}
                    handleChange={handleCardView}
                    isOverView={true}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OverView;
